import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, Home } from "lucide-react";

export default function AppHeader({ title, right = null }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          {!isHome && (
            <Link
              to="/"
              data-testid="header-home-link"
              className="h-11 w-11 flex items-center justify-center rounded-md border border-zinc-200 hover:bg-zinc-50 transition"
              title="Übersicht"
            >
              <Home className="h-5 w-5" />
            </Link>
          )}
          <Link to="/" className="hidden md:block h-12 shrink-0">
            <img
              src="/branding/logo.jpg"
              alt="Theatergruppe Seekirchen"
              className="h-12 w-auto object-contain"
              data-testid="header-logo"
            />
          </Link>
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-bold">
              Theatergruppe Seekirchen · Kassa
            </p>
            <h1 className="text-xl md:text-2xl font-black tracking-tight text-zinc-950" data-testid="header-title">
              {title}
            </h1>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {right}
          <div className="hidden md:flex flex-col text-right">
            <span className="text-xs text-zinc-500">Angemeldet</span>
            <span className="text-sm font-semibold text-zinc-900" data-testid="header-user-email">
              {user?.email}
            </span>
          </div>
          <button
            data-testid="logout-btn"
            onClick={handleLogout}
            className="h-11 px-4 rounded-md border border-zinc-200 hover:bg-zinc-50 transition flex items-center gap-2 text-sm font-semibold"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Abmelden</span>
          </button>
        </div>
      </div>
    </header>
  );
}
